var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ show: _vm.is_visible },attrs:{"src":_vm.alevelSrc,"alt":"alevel-icon"},on:{"load":_vm.setVisible}})
}
var staticRenderFns = []

export { render, staticRenderFns }